/** @format */

import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import api from "../../api/api";

// Centralisation des routes API
const API_ROUTES = {
  ADD_TO_WISHLIST: "/api/wishlist/add_to_wishlist",
  GET_WISHLIST_PRODUCTS: "/api/wishlist/get_wishlist_products/",
  REMOVE_WISHLIST_PRODUCT: "/api/wishlist/remove_wishlist_product/",
  ADD_TO_CARD: "/api/card/add_to_card",
  GET_CARD_PRODUCTS: `/api/card/product/`,
  DELETE_CARD_PRODUCT: "/api/card/delete_product/",
  UPDATE_PRODUCT_QUANTITY: "/api/card/update_product_quantity/",
};

// Fonction utilitaire pour la gestion des messages d'erreur
const getErrorMessage = (error) =>
  error.response?.data.message || error.message;

export const add_To_card = createAsyncThunk(
  "card/add_To_card",
  async (info, { rejectWithValue, fulfillWithValue }) => {
    try {
      const { data } = await api.post(API_ROUTES.ADD_TO_CARD, info, {
        withCredentials: true,
      });
      //console.log("API Response card:", data); // Log the API response
      return fulfillWithValue(data);
    } catch (error) {
      // console.error("Error adding to card", error);
      return rejectWithValue(getErrorMessage(error));
    }
  },
);

export const get_card_products = createAsyncThunk(
  "card/get_card_products",
  async (customerId, { rejectWithValue, fulfillWithValue }) => {
    try {
      const { data } = await api.get(
        API_ROUTES.GET_CARD_PRODUCTS + `${customerId}`,
        { withCredentials: true },
      );
      // Cas backend 200 + code EMPTY_CART
      if (data?.code === "EMPTY_CART") return { data: [], code: "EMPTY_CART" };
      // console.log('get card ', data)
      return fulfillWithValue(data);
    } catch (error) {
      console.log("error", error);
      return rejectWithValue(getErrorMessage(error));
    }
  },
);
/*
if(error.response?.status === 404){
       return
   }

*/

export const delete_card_product = createAsyncThunk(
  "card/delete_card_product",
  async (cardId, { rejectWithValue, fulfillWithValue }) => {
    try {
      const { data } = await api.delete(
        API_ROUTES.DELETE_CARD_PRODUCT + `${cardId}`,
        { withCredentials: true },
      );
      return fulfillWithValue(data);
    } catch (error) {
      return rejectWithValue(getErrorMessage(error));
    }
  },
);

export const updateProductQuantity = createAsyncThunk(
  "card/updateProductQuantity",
  async (
    { cardId, newQuantity, state },
    { dispatch, rejectWithValue, getState, fulfillWithValue },
  ) => {
    try {
      const { data } = await api.put(
        API_ROUTES.UPDATE_PRODUCT_QUANTITY + `${cardId}`,
        { cardId, state, newQuantity },
        {
          withCredentials: true,
        },
      );

      // 🔥 On recharge directement le panier APRES update quantité
      const customerId = getState().auth.customerInfo.id;
      if (customerId) {
        dispatch(get_card_products(customerId));
      }
      return fulfillWithValue(data);
    } catch (error) {
      // return rejectWithValue(error.response.data.message);
      return rejectWithValue(getErrorMessage(error));
    }
  },
);

export const add_To_wishlist = createAsyncThunk(
  "wishlist/add_To_wishlist",
  async (info, { rejectWithValue, fulfillWithValue }) => {
    try {
      const { data } = await api.post(
        API_ROUTES.ADD_TO_WISHLIST,
        { info },
        { withCredentials: true },
      );
      //console.log ('api response add to wishlist', data)
      return fulfillWithValue(data);
    } catch (error) {
      // console.log('error add to wishlist', error)
      return rejectWithValue(getErrorMessage(error));
    }
  },
);

export const get_wishlists_products = createAsyncThunk(
  "wishlist/get_wishlists_products",
  async (customerId, { rejectWithValue, fulfillWithValue }) => {
    // console.log('customer id', customerId)
    try {
      const { data } = await api.get(
        API_ROUTES.GET_WISHLIST_PRODUCTS + `${customerId}`,
        { withCredentials: true },
      );
      //console.log('api response get wishlist products', data)
      return fulfillWithValue(data);
    } catch (error) {
      //console.log('error get wishlist products', error)
      return rejectWithValue(getErrorMessage(error));
    }
  },
);

export const remove_wishlist_product = createAsyncThunk(
  "wishlist/remove_wishlist_product",
  async (wishlistId, { rejectWithValue, fulfillWithValue }) => {
    // console.log('wishlist id', wishlistId)
    try {
      const { data } = await api.delete(
        API_ROUTES.REMOVE_WISHLIST_PRODUCT + `${wishlistId}`,
        { withCredentials: true },
      );
      // console.log('api response remove wishlist product', data)
      return fulfillWithValue(data);
    } catch (error) {
      // console.log('error remove wishlist product', error)
      return rejectWithValue(getErrorMessage(error));
    }
  },
);

// Reducer principal
export const cardReducer = createSlice({
  name: "card",
  initialState: {
    successMessage: "",
    messageError: "",
    deleteError: "",
    cardInfo: "",
    card_products: [],
    card_total: 0,
    buy_products_total: 0,
    price: 0,
    card_loading: false,
    wishList_count: 0,
    wishlists: [],
    shipping_fee: 0,
    outOfStock_products: [],
    deleteSuccess: "",
    code: "",
  },
  reducers: {
    setCardInfo: (state, action) => {
      state.cardInfo = action.payload;
    },
    reset_card: (state) => {
      state.card_products = [];
      state.outOfStock_products = [];
      state.card_total = 0;
      state.price = 0;
      state.shipping_fee = 0;
      state.buy_products_total = 0;
    },
    messageClear: (state) => {
      state.messageError = "";
      state.successMessage = "";
      state.deleteError = "";
      state.deleteSuccess = "";
      state.code = "";
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(add_To_card.pending, (state) => {
        state.card_loading = true;
        state.messageError = "";
      })
      .addCase(add_To_card.rejected, (state, action) => {
        state.card_loading = false;
        state.messageError =
          action.payload || "Erreur lors de l'ajout au panier.";
      })
      .addCase(add_To_card.fulfilled, (state, action) => {
        state.card_loading = false;
        state.successMessage =
          action.payload.message || "Produit ajouté au panier.";
        state.card_total += 1;
      })

      .addCase(get_card_products.pending, (state) => {
        state.card_loading = true;
        state.messageError = "";
      })
      .addCase(get_card_products.rejected, (state, action) => {
        state.card_loading = false;
        state.messageError =
          action.payload || "Erreur de recuperation des données.";
        if (action.payload === "Votre panier est vide") {
          state.card_products = [];
          state.card_total = 0;
          state.price = 0;
          state.shipping_fee = 0;
          state.buy_products_total = 0;
          state.outOfStock_products = [];
        }
      })

      .addCase(get_card_products.fulfilled, (state, action) => {
        if (action.payload.code === "EMPTY_CART") {
          state.card_products = [];
          state.price = 0;
          state.shipping_fee = 0;
          state.buy_products_total = 0;
          state.outOfStock_products = [];
          state.card_total = 0;
          state.card_loading = false;

          return;
        }

        state.card_loading = false;
        state.successMessage = action.payload.message;
        state.card_total = action.payload.card_total;
        state.card_products = action.payload.card_products;
        state.price = action.payload.price;
        state.outOfStock_products = action.payload.outOfStock_products;
        state.shipping_fee = action.payload.shipping_fee;
        state.buy_products_total = action.payload.buy_products_total;
      })

      .addCase(delete_card_product.pending, (state) => {
        state.card_loading = true;
        state.deleteError = "";
      })
      .addCase(delete_card_product.rejected, (state, action) => {
        state.card_loading = false;
        state.deleteError =
          action.payload || "Erreur lors de la suppression du produit.";
      })
      // Dans le reducer
      .addCase(delete_card_product.fulfilled, (state, action) => {
        state.card_loading = false;
        state.deleteSuccess =
          action.payload?.message || "Produit supprimé du panier.";
        if (action.payload?.cardId) {
          state.card_products = state.card_products.filter(
            (product) => product.cardId !== action.payload.cardId,
          );
          state.card_total -= 1;
        }
      })
      .addCase(updateProductQuantity.pending, (state) => {
        state.card_loading = true;
        state.messageError = "";
      })
      .addCase(updateProductQuantity.rejected, (state, action) => {
        state.card_loading = false;
        state.messageError =
          action.payload || "Erreur lors de l'ajout au panier.";
      })
      .addCase(updateProductQuantity.fulfilled, (state, action) => {
        state.card_loading = false;
        state.successMessage =
          action.payload.message || "Produit ajouté au panier.";
      })
      .addCase(add_To_wishlist.pending, (state) => {
        state.card_loading = true;
        state.messageError = "";
      })
      .addCase(add_To_wishlist.rejected, (state, action) => {
        state.card_loading = false;
        state.messageError =
          action.payload || "Erreur lors de l'ajout au favoris.";
      })
      .addCase(add_To_wishlist.fulfilled, (state, action) => {
        state.card_loading = false;
        state.successMessage =
          action.payload.message || "Produit ajouté aux favoris.";
        state.wishList_count += 1;
      })
      .addCase(get_wishlists_products.pending, (state) => {
        state.card_loading = true;
        state.messageError = "";
      })
      .addCase(get_wishlists_products.rejected, (state, action) => {
        state.card_loading = false;
        state.messageError =
          action.payload || "Erreur lors de la récupération des produits.";
      })
      .addCase(get_wishlists_products.fulfilled, (state, action) => {
        state.card_loading = false;
        state.wishlists = action.payload.wishlists;
        state.wishList_count = action.payload.wishList_count;
      })

      .addCase(remove_wishlist_product.pending, (state) => {
        state.card_loading = true;
        state.deleteError = "";
      })
      .addCase(remove_wishlist_product.rejected, (state, action) => {
        state.card_loading = false;
        state.deleteError =
          action.payload || "Erreur lors de la suppression du produit.";
      })
      .addCase(remove_wishlist_product.fulfilled, (state, action) => {
        state.card_loading = false;
        state.successMessage =
          action.payload.message || "Produit supprimé des favoris.";
        if (action.payload?.wishlistId) {
          state.wishlists = state.wishlists.filter(
            (wishlist) => wishlist.wishlistId !== action.payload.wishlistId,
          );
          state.wishList_count -= 1;
        }
        // state.wishlists = action.payload.wishlists;
      });
  },
});

export const { setCardInfo, messageClear, reset_card } = cardReducer.actions;
export default cardReducer.reducer;
